import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared-module/seguridad/services/auth.guard';
import { HomeComponent } from './views/home/home.component';
import { RegistroComidaComponent } from './views/registro-comida/registro-comida.component';
import { MantenerPreciosComponent } from './views/mantener-precios/mantener-precios.component';
import { MantenerProgramaNutricionComponent } from './views/mantener-programa-nutricion/mantener-programa-nutricion.component';




const logisticaRoutes: Routes = [
  { path: 'comedor/home', component: HomeComponent, canActivate: [AuthGuard]},
  { path: 'comedor/registro-comida/:origen', component: RegistroComidaComponent, canActivate: [AuthGuard]},
  { path: 'comedor/precios-comida', component: MantenerPreciosComponent, canActivate: [AuthGuard]},
  { path: 'comedor/empleados', component: MantenerProgramaNutricionComponent, canActivate: [AuthGuard]}, //Feat: T30882 AppComedor Programa nutricional
];

@NgModule({
  imports: [RouterModule.forChild(logisticaRoutes)],
  exports: [RouterModule]
})
export class ComedorRoutingModule {}